/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceRoleCreationDetails } from './ServiceRoleCreationDetails';
import {
    ServiceRoleCreationDetailsFromJSON,
    ServiceRoleCreationDetailsFromJSONTyped,
    ServiceRoleCreationDetailsToJSON,
    ServiceRoleCreationDetailsToJSONTyped,
} from './ServiceRoleCreationDetails';

/**
 * 
 * @export
 * @interface ServiceRoleDefinition
 */
export interface ServiceRoleDefinition {
    /**
     * 
     * @type {string}
     * @memberof ServiceRoleDefinition
     */
    serviceRoleDefinitionUid?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceRoleDefinition
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceRoleDefinition
     */
    profile?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServiceRoleDefinition
     */
    eligibleRoles?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceRoleDefinition
     */
    canBeRemoved?: boolean;
    /**
     * 
     * @type {ServiceRoleCreationDetails}
     * @memberof ServiceRoleDefinition
     */
    creationDetails?: ServiceRoleCreationDetails;
    /**
     * 
     * @type {number}
     * @memberof ServiceRoleDefinition
     */
    minimumInstances?: number;
    /**
     * 
     * @type {number}
     * @memberof ServiceRoleDefinition
     */
    maximumInstances?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceRoleDefinition
     */
    autoDeactivationEnabled?: boolean;
}

/**
 * Check if a given object implements the ServiceRoleDefinition interface.
 */
export function instanceOfServiceRoleDefinition(value: object): value is ServiceRoleDefinition {
    return true;
}

export function ServiceRoleDefinitionFromJSON(json: any): ServiceRoleDefinition {
    return ServiceRoleDefinitionFromJSONTyped(json, false);
}

export function ServiceRoleDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceRoleDefinition {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceRoleDefinitionUid': json['serviceRoleDefinitionUid'] == null ? undefined : json['serviceRoleDefinitionUid'],
        'name': json['name'] == null ? undefined : json['name'],
        'profile': json['profile'] == null ? undefined : json['profile'],
        'eligibleRoles': json['eligibleRoles'] == null ? undefined : json['eligibleRoles'],
        'canBeRemoved': json['canBeRemoved'] == null ? undefined : json['canBeRemoved'],
        'creationDetails': json['creationDetails'] == null ? undefined : ServiceRoleCreationDetailsFromJSON(json['creationDetails']),
        'minimumInstances': json['minimumInstances'] == null ? undefined : json['minimumInstances'],
        'maximumInstances': json['maximumInstances'] == null ? undefined : json['maximumInstances'],
        'autoDeactivationEnabled': json['autoDeactivationEnabled'] == null ? undefined : json['autoDeactivationEnabled'],
    };
}

export function ServiceRoleDefinitionToJSON(json: any): ServiceRoleDefinition {
    return ServiceRoleDefinitionToJSONTyped(json, false);
}

export function ServiceRoleDefinitionToJSONTyped(value?: ServiceRoleDefinition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serviceRoleDefinitionUid': value['serviceRoleDefinitionUid'],
        'name': value['name'],
        'profile': value['profile'],
        'eligibleRoles': value['eligibleRoles'],
        'canBeRemoved': value['canBeRemoved'],
        'creationDetails': ServiceRoleCreationDetailsToJSON(value['creationDetails']),
        'minimumInstances': value['minimumInstances'],
        'maximumInstances': value['maximumInstances'],
        'autoDeactivationEnabled': value['autoDeactivationEnabled'],
    };
}

